var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 1C2.08211 1 2.25 1.16789 2.25 1.375V1.5H7.5C8.05228 1.5 8.5 1.94772 8.5 2.5V3.5V6V6.375C8.5 6.72018 8.22018 7 7.875 7H7.5H3.5H2.25V10.625C2.25 10.8321 2.08211 11 1.875 11C1.66789 11 1.5 10.8321 1.5 10.625V7V1.5V1.375C1.5 1.16789 1.66789 1 1.875 1ZM3.5 8V7.75H7.875C8.63439 7.75 9.25 7.13439 9.25 6.375V3.5H9.5C10.0523 3.5 10.5 3.94772 10.5 4.5V8C10.5 8.55228 10.0523 9 9.5 9H4.5C3.94772 9 3.5 8.55228 3.5 8Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFill);
export default __webpack_public_path__ + "static/media/flag-fill.6a98ed64f4e16d21dff26ad510dae670.svg";
export { ForwardRef as ReactComponent };